import { useEffect, useState, forwardRef } from "react";
import ReactDOM from "react-dom";
import CheckBoxBase from "./FieldTypeBase/CheckBox_Base.js";

const CheckBoxInline = forwardRef((props, ref) => {
  const [container, setContainer] = useState(null);

   useEffect(() => {
    let attempts = 0;
    const interval = setInterval(() => {
        const el = document.getElementById(props.field.containerId);
        if (el) {
        setContainer(el);
        clearInterval(interval);
        } else if (attempts++ > 10) {
        clearInterval(interval);
        console.warn("Portal container not found:", props.field.containerId);
        }
    }, 100); // retry every 100ms up to 1s

  return () => clearInterval(interval);
}, [props.field.containerId]);

  if (!container) return null;

  return ReactDOM.createPortal(
    <span
      key={props.objectkey}
      id={props.objectkey}
      className={`checkbox field checkbox-inline ${props.field.class || ""}`}>

      <CheckBoxBase {...props} ref={ref} /> 

    </span>,
    container
  );
});

export default CheckBoxInline;
